export const EDIT_OPEN = 'editOpen';
export const EDIT_MAIN = 'editMain';
export const EDIT_SERVICE = 'editService';

export const defaultEditState = {
  editOpen: true,
  editMain: false,
  editService: false,
};

export function initEditState() {
  return JSON.parse(JSON.stringify(defaultEditState));
}
